import React from "react";
import aboutImage from "../assets/aboutUsImg.webp";

const About: React.FC = () => {
  return (
    <section id="about" className="py-24 bg-black">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/5] bg-zinc-900 rounded-sm overflow-hidden relative">
              <img src={aboutImage} alt="Prestige Event" className="absolute inset-0 w-full h-full object-cover" />
              {/* <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(135deg, #1a1a1a 0%, #0d0d0d 50%, #1a0f00 100%)",
                }}
              /> */}
              {/* <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <div className="text-6xl mb-4">📸</div>
                  <p className="text-zinc-600 text-sm tracking-wider">
                    Votre image ici
                  </p>
                </div>
              </div> */}
              <div className="absolute inset-4 border border-amber-800/20 rounded-sm pointer-events-none" />
            </div>
            <div
              className="absolute -bottom-6 -right-6 w-32 h-32 rounded-sm opacity-20"
              style={{
                background: "linear-gradient(135deg, #BB9D63, transparent)",
              }}
            />
          </div>

          {/* Texte */}
          <div>
            <p className="text-amber-600/60 tracking-[0.3em] uppercase text-xs mb-4">
              Qui sommes-nous
            </p>
            <h2
              className="text-4xl md:text-5xl mb-8 font-display"
              style={{ color: "#BB9D63", lineHeight: 1.2 }}
            >
              L'art de capturer
              <br />
              vos moments
            </h2>

            <div className="space-y-5 text-zinc-400 text-[15px] leading-relaxed">
              <p>
                Chez{" "}
                <span className="text-zinc-200">Prestige Event</span>, nous
                sommes passionnés par la capture de moments joyeux et la
                création de souvenirs durables. Notre entreprise est née de
                notre amour pour les événements festifs et notre désir de
                permettre à tous de vivre une expérience digne d'un tapis
                rouge.
              </p>
              <p>
                Nos vidéobooths sont équipés de photomatons rotatifs à 360°
                avec un iPhone pour une qualité photo et vidéo exceptionnelle,
                ainsi que d'un dispositif iPad permettant de voir et modifier
                les photos et vidéos en temps réel.
              </p>
              <p>
                Nos valeurs reposent sur l'importance de la famille et de la
                joie de partager de bons moments avec nos proches. La rigueur
                et le professionnalisme guident chaque aspect de notre
                travail.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-6">
              {[
                { value: "360°", label: "Rotation" },
                { value: "100+", label: "Événements" },
                { value: "5★", label: "Avis clients" },
              ].map((stat) => (
                <div key={stat.label} className="text-center lg:text-left">
                  <div className="text-2xl font-bold" style={{ color: "#BB9D63" }}>
                    {stat.value}
                  </div>
                  <div className="text-xs text-zinc-600 tracking-wider uppercase mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
